function gql(strings) {
  var result = strings[0]
  for (var i = 1; i < arguments.length; i++) {
    result += arguments[i] + strings[i]
  }
  return { loc: { source: { body: result } } }
}
module.exports = gql
module.exports.default = gql
